import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Admin API
export const adminApi = {
  // Categories
  getCategories: async () => {
    const response = await api.get('/admin/categories');
    return response.data;
  },
  
  createCategory: async (data) => {
    const formData = new FormData();
    formData.append('id', data.id);
    formData.append('name', data.name);
    const response = await api.post('/admin/categories', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  
  updateCategory: async (categoryId, name, newId = null) => {
    const formData = new FormData();
    formData.append('name', name);
    if (newId && newId !== categoryId) {
      formData.append('new_id', newId);
    }
    const response = await api.put(`/admin/categories/${categoryId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  
  deleteCategory: async (categoryId) => {
    const response = await api.delete(`/admin/categories/${categoryId}`);
    return response.data;
  },
  
  // Products
  getProducts: async () => {
    const response = await api.get('/admin/products');
    return response.data;
  },
  
  createProduct: async (data, imageFiles) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('price', data.price);
    if (data.original_price) formData.append('original_price', data.original_price);
    formData.append('category', data.category);
    formData.append('sizes', data.sizes);
    formData.append('colors', data.colors);
    formData.append('is_new', data.is_new || false);
    formData.append('is_sale', data.is_sale || false);
    formData.append('stock', data.stock || 0);
    
    // Handle multiple image files
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach(file => {
        formData.append('images', file);
      });
    }
    
    // Handle image URLs
    if (data.image_urls) {
      formData.append('image_urls', data.image_urls);
    }
    
    const response = await api.post('/admin/products', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  
  updateProduct: async (productId, data, imageFiles) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('price', data.price);
    if (data.original_price) formData.append('original_price', data.original_price);
    formData.append('category', data.category);
    formData.append('sizes', data.sizes);
    formData.append('colors', data.colors);
    formData.append('is_new', data.is_new || false);
    formData.append('is_sale', data.is_sale || false);
    formData.append('stock', data.stock || 0);
    
    // Handle multiple new image files
    if (imageFiles && imageFiles.length > 0) {
      imageFiles.forEach(file => {
        formData.append('images', file);
      });
    }
    
    // Handle existing image URLs (comma-separated)
    if (data.image_urls) {
      formData.append('image_urls', data.image_urls);
    }
    
    formData.append('keep_existing', 'true');
    
    const response = await api.put(`/admin/products/${productId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  
  deleteProduct: async (productId) => {
    const response = await api.delete(`/admin/products/${productId}`);
    return response.data;
  },
  
  // Image upload
  uploadImage: async (imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    const response = await api.post('/admin/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

export default adminApi;
